import React, { useState } from 'react';

function WelcomeScreen({ onGetStarted, onOpenExisting }) {
  const [showFeatures, setShowFeatures] = useState(false);

  const features = [
    {
      icon: '📖',
      title: 'Complete Bible Access',
      description: 'Navigate through all books and chapters with instant verse loading'
    },
    {
      icon: '🔍',
      title: 'Powerful Search',
      description: 'Find verses quickly with full-text Bible search capabilities'
    },
    {
      icon: '📝',
      title: 'Study Guide Builder',
      description: 'Create comprehensive study guides with notes, questions, and observations'
    },
    {
      icon: '🎨',
      title: 'Beautiful Templates',
      description: 'Choose from professionally designed study guide templates'
    },
    {
      icon: '💾',
      title: 'Auto-Save',
      description: 'Never lose your work with automatic saving and manual save options'
    },
    {
      icon: '📤',
      title: 'Export Anywhere',
      description: 'Export your study guides as PDF, Word documents, or HTML files'
    },
    {
      icon: '🎯',
      title: 'Study Tools',
      description: 'Track study time, monitor progress, and take enhanced notes'
    },
    {
      icon: '⚡',
      title: 'Lightning Fast',
      description: 'Optimized performance with keyboard shortcuts for power users'
    }
  ];

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <div className="welcome-header">
          <div className="logo-section">
            <div className="logo">📚</div>
            <h1>Bible Study Guide Creator</h1>
            <p className="tagline">Transform your Bible study experience with powerful, beautiful tools</p>
          </div>
        </div>

        <div className="welcome-actions">
          <button className="btn btn-primary welcome-btn" onClick={onGetStarted}>
            <span className="btn-icon">🚀</span>
            Get Started
          </button>
          <button className="btn btn-secondary welcome-btn" onClick={onOpenExisting}>
            <span className="btn-icon">📂</span>
            Open Existing Guide
          </button>
        </div>

        <div className="welcome-features-toggle">
          <button
            className="btn btn-link"
            onClick={() => setShowFeatures(!showFeatures)}
          >
            {showFeatures ? 'Hide Features' : 'Explore Features'} ▼
          </button>
        </div>

        {showFeatures && (
          <div className="welcome-features">
            <h2>Powerful Features for Deep Bible Study</h2>
            <div className="features-grid">
              {features.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="welcome-footer">
          <div className="quick-tips">
            <h3>Quick Start Tips</h3>
            <ul>
              <li><strong>Ctrl+N:</strong> Create new study guide</li>
              <li><strong>Ctrl+O:</strong> Open existing guide</li>
              <li><strong>Ctrl+S:</strong> Save your work</li>
              <li><strong>Auto-save:</strong> Your work saves automatically every 30 seconds</li>
            </ul>
          </div>
          <div className="version-info">
            <p>Version 1.0.0 • Ready for Bible Study</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;